module.exports = new __parcel__URL__("bossfight_boss_common.4af9d481.png").toString();